export function getDealerId() {
    const doMetaDataScript = document.getElementById("dealeron_website_metadata");
    let dealerId = undefined;
    if (doMetaDataScript?.textContent) {
        try {
            const metadata = JSON.parse(doMetaDataScript.textContent);
            dealerId = metadata.dealerId ? Number.parseInt(metadata.dealerId, 10) : undefined;
        }
        catch (e) {
            console.error("Error parsing dealer metadata", e);
        }
    }
    // Fallback to grabbing window object if needed
    if (!dealerId && typeof globalThis !== "undefined" && globalThis.DlronGlobal_DealerId) {
        dealerId = Number.parseInt(globalThis.DlronGlobal_DealerId, 10);
    }
    if (!dealerId) {
        return 0;
    }
    return dealerId;
}
const ORION_QUERY_PARAM = "useOrionPage";
const ORION_QUERY_ON = "on";
const ORION_QUERY_OFF = "off";
/**
 * Tri-state Orion query override (used for preview/QA), which bypasses the dealer's CLNTBAA toggle.
 * Shared by the Track Price CTA, the save heart, and the saved-vehicles page so they preview
 * consistently.
 *   - `?useOrionPage=on`  -> true  (force Orion on)
 *   - `?useOrionPage=off` -> false (kill switch: force Orion off, even for Orion dealers)
 *   - absent / any other value -> null (no override; fall back to the dealer's CLNTBAA flag)
 */
export const getOrionQueryOverride = () => {
    const value = new URLSearchParams(globalThis.location.search)
        .get(ORION_QUERY_PARAM)
        ?.toLowerCase();
    if (value === ORION_QUERY_ON) {
        return true;
    }
    if (value === ORION_QUERY_OFF) {
        return false;
    }
    return null;
};
